module.exports = __webpack_public_path__ + "static/images/graph.babb1e8ad9fe3f2df395b298ac4c793d.svg";